import React from 'react';
import { User } from 'styled-icons/fa-solid/User';
import { ImageWithFallback, ImageWithFallbackProps } from './ImageWithFallback';

type Props = {
  title?: string;
  firstName: null | string;
  lastName?: null | string;
} & ImageWithFallbackProps;

export const Avatar = ({ src, title, firstName, lastName, ...styledProps }: Props) => {
  return (
    <ImageWithFallback className="avatar" title={title} src={src} {...styledProps}>
      <Fallback firstName={firstName} lastName={lastName} />
    </ImageWithFallback>
  );
};

Avatar.defaultProps = {
  mr: 5,
  size: 34,
  bg: 'paleSkyBlue',
  color: 'darkGreyBlue'
};

type FallbackProps = { firstName?: string; lastName?: string };
const Fallback = ({ firstName, lastName }: FallbackProps) => {
  const name = [firstName, lastName]
    .filter(Boolean)
    .map(name => name[0])
    .join('')
    .toUpperCase();

  return name || <User size={20} />;
};
